angular.module('ikeweb.map').controller('MapViewController', ['$scope', 'spikeCaptureService', 'pubSubService', 'captureMapTopics', 'mapTopics', 'localStorageService',
    function($scope, spikeCaptureService, pubSubService, captureMapTopics, mapTopics, localStorageService) {

        var capturesOnMap = [];
        var selectedCaptureIds = [];

        function storeMapZoom(zoom) {
            localStorageService.set('map.zoom', zoom);
        }

        function storeMapLocation(location) {
            localStorageService.set('map.location', JSON.stringify(location));
        }

        function setSelectedCaptures(data) {
            selectedCaptureIds = data;
        }

        this.center = {
            location: JSON.parse(localStorageService.get('map.location')),
            zoom: localStorageService.get('map.zoom')
        };

        this.getSelectedCaptures = function() {
            return capturesOnMap.filter(function(capture) {
                return selectedCaptureIds.indexOf(capture.getId()) > -1;
            });
        };

        pubSubService.subscribe(mapTopics.MAP.ZOOM.CHANGE, storeMapZoom);
        pubSubService.subscribe(mapTopics.MAP.LOCATION.CHANGE, storeMapLocation);
        pubSubService.subscribe(mapTopics.MAP.MARKER.SELECTED, setSelectedCaptures);

        $scope.$on('$destroy', function() {
            pubSubService.unsubscribe(mapTopics.MAP.ZOOM.CHANGE, storeMapZoom);
            pubSubService.unsubscribe(mapTopics.MAP.LOCATION.CHANGE, storeMapLocation);
            pubSubService.unsubscribe(mapTopics.MAP.MARKER.SELECTED, setSelectedCaptures);
        });

        function setCapturesOnMap(captures) {
            capturesOnMap = captures;
            pubSubService.publish(captureMapTopics.MAP.CAPTURES.LOAD, capturesOnMap);
        }

        spikeCaptureService.listCaptures().then(setCapturesOnMap);
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/map/map.view.controller.js
// module id = 588
// module chunks = 0